export const config = [
  {
    y1: { name: "Total NISD", type: "column", title: "No.of Applications" },
    y2: { name: "Total ISD", type: "column", title: "No.of Applications" },
    x: { name: "Year", title: "Year" },
    y3: {
      name: "Avg Processing Days NISD",
      type: "spline",
      title: "In Days",
    },
    y4: { name: "Avg Processing Days ISD", type: "spline", title: "In Days" },
  },
];

export const data = [
  { y1: "2242", y2: "257", x: "2014", y3: "18", y4: "91" },
  { y1: "129209", y2: "32960", x: "2015", y3: "37", y4: "107" },
  { y1: "1750800", y2: "681137", x: "2016", y3: "31", y4: "121" },
  { y1: "1846502", y2: "688570", x: "2017", y3: "30", y4: "114" },
  { y1: "2433277", y2: "1675733", x: "2018", y3: "45", y4: "154" },
  { y1: "2624379", y2: "1776044", x: "2019", y3: "41", y4: "206" },
  { y1: "2438784", y2: "1902960", x: "2020", y3: "33", y4: "154" },
  { y1: "2875245", y2: "2425029", x: "2021", y3: "29", y4: "175" },
  { y1: "3420153", y2: "2557523", x: "2022", y3: "19", y4: "123" },
  { y1: "3515518", y2: "2748121", x: "2023", y3: "19", y4: "59" },
  { y1: "3562879", y2: "2788645", x: "2024", y3: "14", y4: "33" },
  { y1: "2050008", y2: "1316672", x: "2025", y3: "12", y4: "28" },
];
